/**
 * Constants for ServiceabilityInfoStep component
 */

export const API_ERROR_LOG_MESSAGE = 'API Errors:';
export const ROUTE_REMOVED_SUCCESS_MESSAGE = 'Route removed successfully';
export const ROUTE_UPDATED_SUCCESS_MESSAGE = 'Route updated successfully';

export const CITY_OPTIONS = [
	{ value: 'Bangalore', label: 'Bangalore' },
	{ value: 'Mumbai', label: 'Mumbai' },
	{ value: 'Delhi', label: 'Delhi' },
	{ value: 'Hyderabad', label: 'Hyderabad' },
	{ value: 'Chennai', label: 'Chennai' },
];

export const MOVEMENT_TYPE_OPTIONS = [
	{ value: 'Intercity', label: 'Intercity' },
	{ value: 'Intracity', label: 'Intracity' },
];
